// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import {hrocChecklistsSubRoute} from '@features/hroc-checklists'
import {FeatureTranslationsLoader} from '@hconnect/common/localization-loaders'
import {useFundamentalMuiTheme} from '@hconnect/uikit'
import {usePlantIdFromHierarchyId} from '@hproduce/suite-core'
import {ThemeProvider} from '@mui/material'
import {RouteObject} from 'react-router'

import {shiftEventsFeatureTranslations} from '../localization'
import {EventsPage} from '../pages'

const SuiteShiftEventsPage = () => {
  const plantId = usePlantIdFromHierarchyId()

  if (!plantId) {
    return null
  }

  return <EventsPage plantId={plantId} />
}

const ShiftEventsRouteWrapper = () => {
  return (
    <FeatureTranslationsLoader translations={shiftEventsFeatureTranslations}>
      <ThemeProvider theme={useFundamentalMuiTheme()}>
        <SuiteShiftEventsPage />
      </ThemeProvider>
    </FeatureTranslationsLoader>
  )
}

export const shiftEventsRoutes: RouteObject = {
  path: '*',
  children: [
    {
      index: true,
      element: <ShiftEventsRouteWrapper />
    },
    hrocChecklistsSubRoute
  ]
}
